module.exports = "<wor-icon\n  [icon]=\"getIcon()\"\n  size=\"sm\" theme=\"font-awesome\"\n  *ngIf=\"_isExpandable()\">\n</wor-icon>\n";